module.exports = __webpack_public_path__ + "static/media/ic-left-blue.e0fe1931.svg";